import React, { useState } from 'react'


import './Tab.scss';
import DashboardView from './Overview/DashboardView';
import { Categorychart } from './Category/Categorychart';
import RegionalTab from './RegionalTab/RegionalTabs';
import ovevricon from  "../../../../../../Assets/AppComponent/Customersupport_icon/Overviewicon.svg"
import categoryicon from  "../../../../../../Assets/AppComponent/Customersupport_icon/Categoryselected.svg"
import regionalicon from  "../../../../../../Assets/AppComponent/Customersupport_icon/regionalicon.svg"
import ticketicons from  "../../../../../../Assets/AppComponent/Customersupport_icon/Tickets_icon.svg"


// unselected 
import ovevricon_dark from  "../../../../../../Assets/AppComponent/Customersupport_icon/Seletectedoverview.svg"
import categoryicon_dark from  "../../../../../../Assets/AppComponent/Customersupport_icon/Categoryicon.svg"
import regionalicon_dark from  "../../../../../../Assets/AppComponent/Customersupport_icon/RegionIcon.svg"
import ticketicons_dark from  "../../../../../../Assets/AppComponent/Customersupport_icon/Ticketsicon.svg"
import { Ticketlist } from './Ticket_records/Ticketlist';
import { useDispatch, useSelector } from 'react-redux';
import {settheInternalSupportsTabActives} from "../../../../../../Redux/Slice"


export const Tabs = ({
  datas,
  PriorityValues,
  SttausValues,
  Client,
  range,
  date,
  Client_id,
    setdates,
  setranges,
  setSelectedRange

}) => {
const tabs = [
  { name: "Overview", icon: ovevricon, un_icon:ovevricon_dark },
  { name: "Tickets", icon: ticketicons ,un_icon : ticketicons_dark },
  { name: "Category", icon:categoryicon , un_icon:categoryicon_dark  },
  // { name: "Regional", icon: regionalicon  , un_icon :regionalicon_dark },
];


  const state = useSelector((state)=>state);
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState(state.StateManagementOverallCall.Internal_supportTabActive);

  return (
    <div className="dashboard-container">

      <div className="tab-section">
    {tabs.map((tab) => (
      <button
        key={tab.name}
        onClick={() => {
          setActiveTab(tab.name);
          dispatch(settheInternalSupportsTabActives(tab.name))

        }}        className={`tab-button ${activeTab === tab.name ? 'active' : ''}`}
      >
        <span className="tab-icon">
          <img src={activeTab === tab.name ? tab.icon: tab.un_icon}/>
        </span>
        <span className="tab-label">{tab.name}</span>
      </button>
    ))}

      </div>

      <div className="tab-content">
        {activeTab === "Overview" && <>
             <DashboardView
              datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
  range={range}
  date={date}
                             Client_id={Client_id}
    setdates={setdates}

      setranges={setranges}
  setSelectedRange={setSelectedRange}

              />
            </>}
        {activeTab === "Tickets" && <div>
          <Ticketlist
            datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
    range={range}
      date={date}
                           Client_id={Client_id}


          
          />
            </div>}
        {activeTab === "Category" && <div>
          <Categorychart 
          
            datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
    range={range}
          date={date}

                           Client_id={Client_id}

          />
          </div>}
        {activeTab === "Regional" && <div>
          <RegionalTab
               datas={datas}
  PriorityValues={PriorityValues}
  SttausValues={SttausValues}
  Client={Client}
    range={range}
      date={date}
                                 Client_id={Client_id}


             
             />
          </div>}
      </div>
    </div>
  );
}
